import type { ClientItem } from "owa-mail-store";

const isSmimeDecoded = (item: ClientItem | undefined): boolean => !!item?.Smime?.isDecoded;

/**
 * Checks if the item is decoded AND has body content present.
 * Returns false if body is missing (stale cache scenario).
 * Use this when you need to verify that decoded content is actually available.
 */
export const isSmimeDecodedWithNormalizedBody = (item: ClientItem | undefined): boolean => isSmimeDecoded(item) && !!item?.NormalizedBody;

export default isSmimeDecoded;
